import { useQuery } from "react-query";

import { getDocuments } from "~/pages/CatalogApplications/catalogApi";

type UseGetDataDocumentsOptions = {
  candidateId: string;
  enabled?: boolean;
};

export default function useGetDataDocuments({
  candidateId,
  enabled = true,
}: UseGetDataDocumentsOptions) {
  return useQuery({
    queryKey: ["getCatalogData", "documents", candidateId],
    queryFn: () => getDocuments(candidateId),
    refetchOnWindowFocus: false,
    enabled: enabled && !!candidateId,
  });
}
